
<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <div
                    class="alert alert-dismissible fade show"
                    :class="alertType"
                    v-if="showAlert==true"
                  >
                    <button
                      type="button"
                      aria-hidden="true"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <i class="nc-icon nc-simple-remove"></i>
                    </button>

                    <div>
                      <span>{{alertMsg}}</span>
                    </div>
                  </div>
                  <h3 slot="header" class="header text-center">Login</h3>

                  <fg-input
                    v-model="email"
                    addon-left-icon="nc-icon nc-single-02"
                    placeholder="Email"
                  ></fg-input>

                  <fg-input
                    v-model="password"
                    addon-left-icon="nc-icon nc-key-25"
                    placeholder="Password"
                    type="password"
                  ></fg-input>

                  <br />

                  <!-- <p-checkbox>Subscribe to newsletter</p-checkbox> -->

                  <p-button
                    native-type="submit"
                    slot="footer"
                    type="info"
                    round
                    block
                    class="mb-3"
                  >Log In</p-button>
                </card>
              </form>
              <div style="text-align:center;">
                <a href="/password-forgot">Forgot Password?</a>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg) "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "@/components/Dashboard/Views/Pages/Layout/AppNavbar";
import AppFooter from "@/components/Dashboard/Views/Pages/Layout/AppFooter";

import firebase, { functions } from "firebase";
import { mapGetters } from "vuex";
export default {
  name: "login",
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      email: "",
      alertMsg: "",
      alertType: "",
      displayAlert: false,
      showAlert: false,
      password: "",
      show: false,
      passwordRules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters"
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  created: function() {
    let msgData = this.$route.query;
    console.log("HERE IS THE CONFIRM DATA: ", msgData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;

    if (msgData.msg_show == 'true') {
      console.log("SHOW MESSAGE IS TRUE")
      this.displayAlert = true;
      this.showAlert = true;
    }
  },
  methods: {
    ...mapGetters(["profileStore"]),
    login: function(e) {
      let self = this;
      e.preventDefault();
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            //console.log(JSON.stringify(user));
            //alert(`You are logged in as ${user}`);
            try {
              /*console.log(
                "USER LOGIN TOKEN: ",
                firebase.auth().currentUser.uid
              );

              console.log("URL QUERY:", self.$route.query);
              console.log("REDIRECT VALUE", self.$route.query.redirect);
*/
              if (typeof self.$route.query.redirect !== "undefined") {
                self.$router.push({
                  path: decodeURIComponent(self.$route.query.redirect)
                });
                return;
              }

              self.$router.push({
                path: "/"
              });
            } catch (err) {
              // console.log("THERE WAS AN ERROR:", err);
              self.$router.push({
                path: "/"
              });
            }
          },
          err => {
            //console.log("THERE WAS AN ERROR:", err.code);

            if (err.code === "auth/invalid-email") {
              self.alertMsg = "Please enter a valid email.";
              self.showAlert = true;
              self.displayAlert = true;
              self.alertType = "alert-danger";
            }
            if (err.code === "auth/wrong-password") {
              self.alertMsg =
                "The password is invalid or the user does not have a password.";
              self.showAlert = true;
              self.displayAlert = true;
              self.alertType = "alert-danger";
            }

            if (err.code === "auth/user-not-found") {
              self.alertMsg = "Please check login to confirm it is valid.";
              self.showAlert = true;
              self.displayAlert = true;
              self.alertType = "alert-danger";
            }

            self.displayAlert = true;
            self.showAlert = true;
            self.alertType = "alert-danger";
            //alert(err.message);
          }
        );
    }
  }
};
</script>
<style scoped>
</style>